export default __webpack_public_path__ + "static/media/delete_popup_icon.a7df4110.svg";